/**
 * User Roles Constants
 * 
 * This file contains all possible user roles used throughout the frontend application.
 * These constants should be used instead of hard-coded role strings to ensure consistency
 * and make refactoring easier. Values must match exactly with backend enum RoleName.
 */

export const HR = 'HR';
export const BROKER = 'Broker';
export const CRM = 'CRM';
export const CLAIMS_OFFICER = 'Claims_Officer';
export const APPROVER = 'Approver';
export const FINANCE = 'Finance';
export const ADMIN = 'Admin';

// Helper object for easy access and iteration
export const USER_ROLES = {
  HR,
  BROKER,
  CRM,
  CLAIMS_OFFICER,
  APPROVER,
  FINANCE,
  ADMIN
};

// Role display labels for UI
export const USER_ROLE_LABELS = {
  [HR]: 'HR',
  [BROKER]: 'Broker',
  [CRM]: 'CRM',
  [CLAIMS_OFFICER]: 'Claims Officer',
  [APPROVER]: 'Approver',
  [FINANCE]: 'Finance',
  [ADMIN]: 'Admin'
};

// Roles that can process claims
export const PROCESSING_ROLES = [CLAIMS_OFFICER, APPROVER, FINANCE, ADMIN];

// Roles that have administrative privileges
export const ADMIN_ROLES = [ADMIN];

// Roles that can approve claims
export const APPROVAL_ROLES = [APPROVER, ADMIN];
